import { firestore } from './firebase';

export async function sendMail(messageData: any) {
  return firestore().collection('mail').add(messageData);
}
